let dynamicRoutes = {
  routes: [],
  addDynamicComponents () {
    this.routes.forEach(route => {
      const template = route.template
      route.component = () => {
        return import(`@/app/templates/${template}.vue`)
      }
    })
  },

  addDynamicRoutesTo (router) {
    this.routes = [
      {
        'content': 'none',
        'contentType': 'Naujienos',
        'path': '/naujienos',
        'template': 'NewsList'
      },
      {
        'content': 'none',
        'contentType': 'Naujienos',
        'path': '/naujienos/:0',
        'template': 'NewsPost'
      },
      {
        'content': '-LbDsunxBL5FFKLTDVQV',
        'contentType': 'Puslapiai',
        'path': '/apie-mus',
        'template': 'Puslapis'
      },
      {
        'content': 'XhsplBEAACMAOXUq',
        'contentType': 'Puslapiai',
        'path': '/paslaugos',
        'template': 'Puslapis'
      },
      {
        'content': '-LdenvQyXAP66sRz772B',
        'contentType': 'Puslapiai',
        'path': '/kontaktai',
        'template': 'Kontaktai'
      },
      {
        'content': '-LdenvQyXAP66sRz772B',
        'contentType': 'Galerija',
        'path': '/galerija',
        'template': 'Galerija'
      }
    ]
    this.addDynamicComponents()
    router.addRoutes(this.routes)
  }
}

export default dynamicRoutes
